import { Inject, Prop, Ref, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import reportRelated from '@/entities/report-insights/report-related-peoples/report-related-people.vue';
import reportReferent from '@/entities/report-insights/report-referent/report-referent.vue';
import { namespace } from 'vuex-class';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import BriefingService from '@/service/briefing.service';
import bodyComponent from '@/entities/report-insights/template-report/template-one/body-component';
import { DataTmp, groupByComponentName, groupByNameHeading, groupByNameTable } from '@/entities/report-insights/report-common';
import referenceComponent from '@/entities/report-insights/template-report/template-one/reference-component';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { convertToBriefingResourceReq, isNullish, isScriptLoaded } from '@/util/ds-util';
import { VueHtmlToPaper } from '@/entities/report-insights/printf.report';
import ReportContent from '@/entities/report-insights/report-content/report-content.vue';
import { calculateReadTime, checkToShow } from '@/util/common-util';
import { FILE_TYPES_ENUM, URL_S3_POLARIS } from '@/constants';
import AskConversation from '@/v2/home/ask-goover/ask-conversation/ask-conversation.vue';
import { isPaidUser } from '@/util/paid-user-util';
import ReportComments from '@/entities/report-insights/comments/ReportComments.vue';
import { PAGES } from '@/shared/constants/ds-constants';
import { checkIsGuestAccount } from '@/util/guest-util';
import ScrapAgentService from '@/service/scrap-agent.service';
import { v4 as uuidv4 } from 'uuid';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

export const innitReportDetails: ReportData = {
  id: '',
  _id: '',
  title: '',
  img: '',
  type: '',
  resourceType: '',
  language: '',
  components: '',
  referenceDocIds: [],
  formattedCreatedAt: '',
  scrapboardId: '',
  is_scrap: false,
  created_at: '',
};

export interface ReportData {
  id: string;
  _id: string;
  title: string;
  img: string;
  type: string;
  resourceType: string;
  language: string;
  components: any;
  referenceDocIds: any[];
  formattedCreatedAt: string;
  scrapboardId: string;
  is_scrap: boolean;
  created_at: string;
}

export const innitHealing: any = {
  data: {
    date: {
      content: '',
    },
    publisher: {
      content: '',
    },
    subtitle: '',
    title: '',
    title_image: {
      content: '',
    },
  },
  component: '',
  arrDocId: [],
};
export const innitDataTableOfContent = {
  data: {
    table_of_entry: [],
    table_of_section: new DataTmp(),
  },
  component: '',
  arrDocId: [],
};
@Component({
  computed: {
    PAGES() {
      return PAGES;
    },
  },
  methods: { checkToShow },
  components: {
    'report-comment': ReportComments,
    'reference-component': referenceComponent,
    'body-component': bodyComponent,
    vueCustomScrollbar: vueCustomScrollbar,
    'report-content': ReportContent,
    reportRelated,
    reportReferent,
    'ask-sub': AskConversation,
  },
})
export default class myReports extends Vue {
  scrollSettings = {
    wheelPropagation: false,
  };
  @Prop() items: any[] | [];
  @appStoreState.Getter
  public isShowDetailReport!: boolean;
  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;
  @briefingStore.Mutation
  public updateTotalResources!: (payload: number) => void;
  @briefingStore.Mutation
  public updateAddingResources!: (payload: IResourceModel) => void;
  selectedComponent = '';
  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailArticles!: (state?: boolean) => void;
  @briefingStore.Mutation
  public setSelectedResource!: (payload?: any) => void;

  @briefingStore.Mutation
  public setUpdateResources!: (payload?: any) => void;

  @appStoreState.Mutation
  public setIsShowShareReport!: (payload: boolean) => void;

  @briefingStore.Getter
  public getIsHideSelectedResourceItem!: boolean;

  @briefingStore.Mutation
  public setIsHideSelectedResourceItem!: (payload: any) => void;

  @briefingStore.Mutation
  public setStoreReferenceDocumentsForReport!: (payload: any) => void;

  @appStoreState.Mutation
  public setIsShowReportWarningCloseAfterEdit!: (payload?: boolean) => void;

  @briefingStore.Mutation
  public setReloadAfterEditedReport!: (payload?: boolean) => void;

  @briefingStore.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @appStoreState.Mutation
  public setIsCanShowCreateAgent!: (isCanShowCreateAgent: boolean) => void;

  @briefingStore.Mutation
  public setIsCreateNewBriefingFromChat!: (IsCreateNewBriefingFromChat: boolean) => void;

  @appStoreState.Mutation
  public setShowCreateBriefing!: (isShowCreateBriefing: boolean) => void;

  @Inject('scrapAgentService')
  public scrapAgentService!: () => ScrapAgentService;

  updatingBookmark = false;

  @Ref() contentToPrint!: HTMLDivElement;
  @Ref() imageRef!: null;
  reportDetail: any = innitReportDetails;
  loading = false;
  contentDetail: any[] = [];
  contentReference: any[] = [];
  clearSelected: any = 0;
  allRelatedReference: any[] = [];
  headingSelected: any = '';
  articleRelatedPeople: any[] = [];
  articleRelatedDocument: IResourceModel[] = [];
  startIndex = 0;
  numberItemPerPage = 4;
  endIndex = this.startIndex + this.numberItemPerPage;
  dataHeading = innitHealing;
  displayPolarisView = false;
  displayPolarisEdit = false;
  conversationId = '';
  dataTableOfContent = {
    data: {
      table_of_entry: [],
      table_of_section: new DataTmp(),
    },
    component: '',
    arrDocId: [],
  };

  dataBody = [];
  dataReference = {};
  logo = '';
  reportType = '';
  screenWidth = window.innerWidth;
  polarisAPI = null;
  documentType = '';
  fileNameDownloadFromS3 = '';
  fileBlobDownloadFromS3 = null;
  isEdited = false;
  openPolaris = false;
  isSave = false;
  reloadAfterSave = false;
  userLogin = '';
  downloadAt = 0;

  @Inject('discoveryService')
  public discoveryService: () => DiscoveryAndReportService;
  @Inject('briefingService')
  private briefingService: () => BriefingService;

  isShowReportRef = true;
  isEditedReferenceDocuments = false;

  created() {
    if (!isScriptLoaded(URL_S3_POLARIS)) {
      const plugin = document.createElement('script');
      plugin.setAttribute('src', URL_S3_POLARIS);
      plugin.async = true;
      plugin.defer = true;
      document.head.appendChild(plugin);
    }
    this.userLogin = this.$store.getters?.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id;
    this.setReloadAfterEditedReport(false);
  }

  get isGuest() {
    return checkIsGuestAccount();
  }

  get userKey() {
    return this.$store.getters?.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser')).id;
  }

  get isMyReport() {
    return this.userKey === this.getSelectedResource.owner_user_key;
  }

  handleClosePopup() {
    this.setStoreReferenceDocumentsForReport([]);
    this.setSelectedResource({});
    this.setShowDetailReport(false);
    const button = document.getElementById('buttonCloseReportDetail');
    if (this.reloadAfterSave) {
      this.setReloadAfterEditedReport(true);
    }
    if (button) {
      button.click();
    }
  }

  mounted() {
    const hashConversation = window.location.hash;
    if (hashConversation.startsWith('#ask=')) {
      this.isShowReportRef = false;
      this.conversationId = hashConversation.replace('#ask=', '');
    }
    this.isEditedReferenceDocuments = false;
    const showReportFromS3 = this.getSelectedResource?.originParentDocDetail?.media_type || [];
    const checkMediaType = showReportFromS3.includes(FILE_TYPES_ENUM.DOCX.toUpperCase());
    if (!isNullish(this.getSelectedResource) && checkMediaType) {
      this.getDataReference();
      this.displayPolarisView = true;
      this.isEdited = true;
      this.openPolaris = true;
    }
    if (!isNullish(this.getSelectedResource) && this.isShowDetailReport === true) {
      this.getDataDetail();
      // this.getRelatedPeople();
      this.getCountShare();
    }
    window.addEventListener('resize', this.handleResize);
  }

  updated() {
    if (this.displayPolarisView && !this.fileBlobDownloadFromS3) {
      const showReportFromS3 = this.getSelectedResource?.originParentDocDetail?.media_type || [];
      const checkMediaType = showReportFromS3.includes(FILE_TYPES_ENUM.DOCX.toUpperCase());
      if (!isNullish(this.getSelectedResource) && checkMediaType && this.isEdited) {
        this.downloadAndViewReportFromS3(this.getSelectedResource.docId + '.' + FILE_TYPES_ENUM.DOCX, true);
      }
    }
    // if(this.displayPolarisEdit) {
    //   this.removeElementBeforeInitPolaris();
    // }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.screenWidth = window.innerWidth;
  }

  async getCountShare() {
    await this.discoveryService()
      .getCountByType(this.getSelectedResource.docId, 'SHARE')
      .then(res => {
        if (res?.data) {
          const keys = Object.keys(res.data);
          const firstKey = keys[0];
          this.setSelectedResource({
            ...this.getSelectedResource,
            countShare: res.data[firstKey].SHARE,
          });
        }
      });
  }
  async getDataDetail() {
    this.logo = 'content/images/common/goover_logo_mail.png';
    if (!isNullish(this.getSelectedResource)) {
      this.loading = false;
      await this.discoveryService()
        .getDetailService(this.getSelectedResource.docId)
        .then(res => {
          if (res?.data?.objectReport) {
            this.reportDetail = res?.data?.objectReport;
            this.reportType = this.reportDetail.type;
            this.contentReference = this.reportDetail?.referenceDocIds;
            this.allRelatedReference = this.reportDetail?.referenceDocIds;
            const newObj = groupByComponentName(res.data.objectReport?.components);
            this.dataHeading = groupByNameHeading(newObj?.cover_page);
            if (newObj.table_of_contents) {
              this.dataTableOfContent = groupByNameTable(newObj?.table_of_contents);
            }
            this.dataBody = newObj?.body_component;
            const sumContent = this.sumContent(this.dataBody);
            const readTimeMinute = calculateReadTime(sumContent);
            this.dataReference = newObj?.Reference;
            if (this.reportDetail.mlEntity) {
              this.getRelatedArticle();
            }
            if (this.reportDetail.mlEntitySearch) {
              this.getRelatedPeople();
            }

            this.setSelectedResource({
              ...this.getSelectedResource,
              reportType: res?.data?.objectReport?.type || '',
              privateType: res?.data?.objectReport?.privateType || '',
              readTimeMinute,
            });

            this.loading = true;
          } else {
            this.dataHeading = innitHealing;
            // this.dataHeading = {
            //   ...this.dataHeading.data.title_image,
            //   content: `https://goover.ai:7999/thumbnail/insight-cover/def78006-f92b-47ea-8e5e-7fad428b9f78.png`,
            // };

            this.dataTableOfContent = innitDataTableOfContent;
            this.dataBody = [];
            this.dataReference = {};
            this.reportDetail = innitReportDetails;
            this.contentDetail = [];
            this.contentReference = [];
            this.articleRelatedDocument = [];
            this.loading = true;
          }
        });
    }
    this.$emit('contentReference', this.contentReference);
  }

  sumContent(dataBody: any[]) {
    return dataBody.reduce((acc, cur) => {
      return acc.concat(' ').concat(
        cur.elements.reduce((acce, cure) => {
          return acce.concat(' ').concat(cure.content);
        }, '')
      );
    }, '');
  }

  addToNewAgentBriefing() {
    if (checkIsGuestAccount(true)) return;
    const briefingResource = this.convert2ReferenceResource(this.getSelectedResource, false);
    this.setReferenceDocumentsForNewBriefing([briefingResource]);
    this.setIsCanShowCreateAgent(true);
    this.setIsCreateNewBriefingFromChat(false);
    this.setShowCreateBriefing(true);
  }

  convert2ReferenceResource(document: IResourceModel, isUpdateBriefing: boolean) {
    const briefingResource = convertToBriefingResourceReq(
      document,
      this.$store.getters.userIdentity.id,
      this.$route.name,
      this.$store.getters['briefingStore/getSelectedBriefingPage'],
      undefined,
      this.$i18n.locale,
      this.$store.getters?.userIdentity?.lastName,
      undefined,
      isUpdateBriefing
    );
    briefingResource.search_type = document?.originParentDocDetail?.search_type;
    // @ts-ignore
    briefingResource.mediaType = document?.originParentDocDetail?.media_type;
    if (
      (briefingResource.search_type[0] === 'REPORT' && briefingResource.mediaType[0] === 'REPORT') ||
      document.originParentDocDetail.doc_type === 4
    ) {
      briefingResource.originType = 'REPORT';
    } else {
      briefingResource.originType = 'DISCOVERY';
    }
    briefingResource.parentDocId = document.docId;
    briefingResource.owner_user_key =
      typeof briefingResource.owner_user_key === 'string' ? briefingResource.owner_user_key : briefingResource.owner_user_key[0];
    briefingResource['referenceDocumentIndex'] = 1;

    return briefingResource;
  }

  async getDataReference() {
    if (!isNullish(this.getSelectedResource)) {
      await this.discoveryService()
        .getDetailService(this.getSelectedResource.docId)
        .then(res => {
          if (res?.data?.objectReport) {
            this.reportDetail = res?.data?.objectReport;
            this.contentReference = this.reportDetail?.referenceDocIds;
            this.allRelatedReference = this.reportDetail?.referenceDocIds;
          }
        });
    }
    this.$emit('contentReference', this.contentReference);
  }

  imgSource() {
    if (this.dataHeading?.data?.title_image?.content) {
      return this.dataHeading.data.title_image.content;
    } else {
      return '/content/images/';
    }
  }

  selectComponent(component: string, arrDocId) {
    this.selectedComponent = component;
    this.$emit('selectComponent', arrDocId);
  }

  selectBody(component, arrDocId, heading) {
    // this.triggerTabById('#profile');
    this.isShowReportRef = true;
    if (arrDocId) {
      this.contentReference = arrDocId;
    } else {
      this.contentReference = this.reportDetail.referenceDocIds;
    }
    if (heading) {
      this.headingSelected = heading;
    }
    // this.selectedComponent = component;
    this.$emit('selectComponent', arrDocId);
  }

  getRelatedPeople() {
    this.discoveryService()
      .getRelatedPeopleDiscovery(this.getSelectedResource.docId, this.$store?.getters?.userIdentity.id)
      .then(res => {
        if (res?.data) {
          this.articleRelatedPeople = res.data?.body?.entityLinkingResultList;
        }
      });
  }

  getRelatedArticle() {
    this.discoveryService()
      .getRelatedArticlesDiscovery('(london)AND(view)', 1, 'en', 60, 'basic', false)
      .then(res => {
        if (res?.data) {
          this.articleRelatedDocument = res?.data?.data;
        }
      });
  }

  addToResource() {
    if (checkIsGuestAccount(true)) {
      return true;
    }

    // this.setUpdateResources(this.getSelectedResource);
    // this.setSelectedResource({ ...this.getSelectedResource, isBookmarked: !this.getSelectedResource.isBookmarked });
    this.updatingBookmark = true;
    const userKey = this.getSelectedResource.owner_user_key || this.$store.getters?.userIdentity?.id;
    const requestId = uuidv4();
    console.log('getSelectedResource = ', this.getSelectedResource);
    const {
      title,
      url: path,
      content,
      documentType,
      type,
      originParentDocDetail,
      bpId,
      publishAt,
      owner_user_key,
      _id,
      writer,
    } = this.getSelectedResource;
    const requestBody = [
      {
        requestId,
        title,
        path: path || '',
        description: content,
        content,
        type,
        collector: 'UW',
        userKey: userKey,
        originDate: originParentDocDetail.created_at,
        searchTypes: originParentDocDetail.search_type,
        mediaType: originParentDocDetail.media_type,
        imageUri: [],
        imageUriThumbnail: originParentDocDetail.image_uri_thumbnail,
        collectedQuality: originParentDocDetail.collected_quality,
        favicon: '',
        img: '',
        lang: '',
        liked: 0,
        keyword: '',
        getMlEntity: [],
        getMlEntitySearch: [],
        requestBy: userKey,
        parentDocId: originParentDocDetail.parent_doc_id[0],
        parentDocIds: originParentDocDetail.parent_doc_id,
        forcedClustering: false,
        requestedResourceList: originParentDocDetail.parent_doc_id,
        targetBpId: null,
        titleBriefingPage: '',
        isFeed: true,
        htmlRaw: '',
        publishedAt: publishAt,
        serviceHtml: '',
        ownerUserKey: owner_user_key || userKey,
        sameBriefingPage: false,
        docType: 11,
        isInsideGroup: false,
        isGroup: false,
        originType: 'REPORT',
        otherInfo: null,
        chunkId: '',
        chunkText: '',
        _id: null,
        created_at: originParentDocDetail.created_at,
        writer: [writer || 'Goover'],
        author: writer || 'Goover',
        searchType: originParentDocDetail.search_type[0],
        isBookmarked: true,
      },
    ];
    const toggleBookmark = !this.getSelectedResource.isBookmarked;
    const requestPromise = toggleBookmark
      ? this.scrapAgentService().saveDefaultScrapAgentByType(userKey, requestBody)
      : this.briefingService().feedUpdateStatus({
          id: _id,
          briefingPageId: bpId,
          parentDocId: originParentDocDetail?.parent_doc_id[0],
          isBookmarked: false,
          isDeleted: false,
          typeDocument: documentType || 'SCRAPE',
        });
    requestPromise
      .then(response => {
        const changedItem = { ...this.getSelectedResource, isBookmarked: toggleBookmark };
        this.setSelectedResource(changedItem);
        this.setUpdateResources(changedItem);
        this.updateTotalResources(toggleBookmark ? 1 : -1);
        this.updateAddingResources({
          ...this.getSelectedResource,
          isBookmarked: toggleBookmark,
          userProfile: {
            userKey: this.$store.getters?.userIdentity?.id,
            lastName: this.$store.getters?.userIdentity?.lastName,
            imageUrl: this.$store.getters?.userIdentity?.imageUrl,
          },
        });
      })
      .finally(() => {
        this.updatingBookmark = false;
      });
  }

  async printReports() {
    await VueHtmlToPaper.print('contentToPrint', {});
  }

  downloadAsWord() {
    if (!isPaidUser(true)) return;
    // @ts-ignore
    this.$refs.reportContent.downloadAsWord();
    this.downloadAt = new Date().getTime();
    // const elementToConvert = document.getElementById('contentToPrint');  // Your target HTML element
    //
    // html2canvas(elementToConvert).then(canvas => {
    //   // Capture canvas data if needed, here for PDF or image operations
    //   const htmlString = elementToConvert.innerHTML;  // Get the inner HTML
    //
    //   const docxBlob = htmlToDocx(htmlString, null, { orientation: 'portrait' });
    //
    //   // Create a downloadable link for the contents
    //   const link = document.createElement('a');
    //   link.href = URL.createObjectURL(docxBlob);
    //   link.download = 'document.docx';
    //   link.click();
    // });
  }

  imageStyle() {
    return {
      width: '100%',
      display: this.loading ? 'inline' : 'none',
      transition: 'all 1s',
      animation: this.loading ? 'fadeIn 2s linear' : 'none',
    };
  }

  shareReport() {
    this.setIsShowShareReport(true);
  }

  callHideFunction() {
    if (this.getIsHideSelectedResourceItem === false) {
      this.setIsHideSelectedResourceItem(!this.getIsHideSelectedResourceItem);
    } else {
      this.setIsHideSelectedResourceItem(true);
    }
  }

  downloadReportPDF() {
    if (checkIsGuestAccount(true)) return;
    // @ts-ignore
    this.$refs.reportContent.downloadReportAsPDF();
    this.downloadAt = new Date().getTime();
  }

  handleHeadingSelected(headingSelected) {
    this.headingSelected = headingSelected;
  }

  handleContentReference(contentReference) {
    this.contentReference = contentReference;
  }

  handleClearSelected(clearSelected) {
    this.clearSelected = clearSelected;
  }

  handleIsEditedReferenceDocuments(isEditedReferenceDocumentsInput: boolean) {
    this.isEditedReferenceDocuments = isEditedReferenceDocumentsInput !== undefined ? isEditedReferenceDocumentsInput : false;
  }

  handleClickClosePopup() {
    if (this.isEditedReferenceDocuments) {
      this.setIsShowReportWarningCloseAfterEdit(true);
    } else {
      this.handleClosePopup();
    }
  }

  initPolaris(file: any, fileName: any) {
    const containerId = 'weboffice_container';
    if (document.getElementById(containerId).children.length > 0) {
      document.getElementById('weboffice_container').remove();
      this.removeElementBeforeInitPolaris();
    }
    const language = localStorage.getItem('currentLanguage');
    const config = {
      documentType: this.getDocumentType(fileName),
      viewMode: this.displayPolarisEdit ? 'edit' : 'read',
      locale: language,
      // isOpenFocus: true,
      // isSplash: false,
      // zoomRatio: 0.8
    };

    // eslint-disable-next-line
    // @ts-ignore
    PolarisWebOffice(containerId, config)
      .then(WebOfficeAPI => {
        const API = WebOfficeAPI[config.documentType];
        this.polarisAPI = API;
        // Open the file in Polaris Web Office
        API.openDocument({
          name: fileName,
          blob: file,
        }).then(() => {
          this.openPolaris = false;
          const canvas = document.getElementById('weboffice-container')?.getElementsByTagName('canvas');
          console.log('canvas = ', canvas);
          // console.log('File opened successfully in Polaris Web Office.');
        });
      })
      .catch(error => {
        this.openPolaris = false;
        console.error('Polaris Web Office initialization failed:', error);
      });
  }

  getDocumentType(fileName) {
    if (fileName.endsWith('.docx')) return 'word';
    if (fileName.endsWith('.pptx')) return 'slide';
    if (fileName.endsWith('.xlsx')) return 'sheet';
    return 'word';
  }

  getFileDoc(file: any, fileName: any) {
    if (file && fileName) {
      this.initPolaris(file, fileName);
    }
  }

  togglePolarisView() {
    this.displayPolarisView = !this.displayPolarisView;
    this.displayPolarisEdit = false;
  }

  togglePolarisEdit() {
    if (!isPaidUser(true)) return;
    this.displayPolarisEdit = !this.displayPolarisEdit;
    const showReportFromS3 = this.getSelectedResource?.originParentDocDetail?.media_type || [];
    console.log(showReportFromS3);
    const checkMediaType = showReportFromS3.includes(FILE_TYPES_ENUM.DOCX.toUpperCase());
    if (!this.isEdited && !this.displayPolarisEdit && !checkMediaType) {
      this.displayPolarisView = this.displayPolarisEdit ? !this.displayPolarisEdit : this.displayPolarisEdit;

      if (!isNullish(this.getSelectedResource) && this.isShowDetailReport === true) {
        this.getDataDetail();
        // this.getRelatedPeople();
      }
    } else if (this.displayPolarisEdit && this.isEdited) {
      this.displayPolarisView = false;
      this.initPolaris(this.fileBlobDownloadFromS3, this.fileNameDownloadFromS3);
    } else if (!this.displayPolarisEdit && this.isEdited) {
      this.displayPolarisView = true;
      const fileName = this.getSelectedResource.docId + '.' + FILE_TYPES_ENUM.DOCX;
      this.downloadAndViewReportFromS3(fileName, true);
    }
  }

  async saveDocument() {
    let fileName = '';
    let fileBlob: any;
    let checkPushFileToS3 = false;
    this.isSave = true;
    if (this.polarisAPI && typeof this.polarisAPI.saveDocument === 'function') {
      await this.polarisAPI
        .saveDocument()
        .then(async documentDownload => {
          fileName = this.getSelectedResource.docId + '.' + FILE_TYPES_ENUM.DOCX;
          const file = new File([documentDownload.blob], fileName, { type: documentDownload.blob?.type });
          fileBlob = documentDownload.blob;
          this.documentType = documentDownload.blob?.type;
          checkPushFileToS3 = await this.discoveryService()
            .uploadFileToS3(fileName, file)
            .then(res => {
              // console.log('res:', res);
              // console.log('successfully uploaded document to S3.');
              if (res && res.data) {
                this.isEdited = true;
              }
              this.reloadAfterSave = true;
              this.isSave = false;
              return res.data;
            });
          // Additional logic, such as uploading the saved document to a server
          // const link = document.createElement('a');
          // link.href = URL.createObjectURL(documentDownload.blob);
          // link.download = documentDownload.name;
          // link.click();
        })
        .catch(error => {
          this.isSave = false;
          console.error('Error saving document:', error);
        });
      if (checkPushFileToS3) {
        await this.openReportAfterEdited(fileName);
      }
    } else {
      this.isSave = false;
      console.error('saveDocument function is not available in the API.');
    }

    await this.saveEditedReport();
  }

  async saveEditedReport() {
    const docId = this.getSelectedResource.docId;
    const bpId = this.getSelectedResource.bpId || [];
    if (docId) {
      await this.discoveryService()
        .saveEditedReport(docId, FILE_TYPES_ENUM.DOCX.toUpperCase(), 4, bpId)
        .then(() => {
          // console.log('Saved edited report successfully.');
        })
        .catch(err => {
          console.error('Error saving edited report:', err);
        });
    }
  }

  async openReportAfterEdited(fileName: string) {
    this.displayPolarisEdit = false;
    this.displayPolarisView = true;
    await this.downloadAndViewReportFromS3(fileName, true);
  }

  async downloadAndViewReportFromS3(fileName: string, viewMode: boolean) {
    if (viewMode) {
      this.removeElementBeforeInitPolaris();
    }
    await this.discoveryService()
      .downloadReportFileFromS3(fileName)
      .then(res => {
        if (res && res.data) {
          console.log('view = ', viewMode);
          if (viewMode) {
            this.initPolaris(res.data, fileName);
          }
          this.fileNameDownloadFromS3 = fileName;
          this.fileBlobDownloadFromS3 = res.data;
        }
      });
  }

  removeElementBeforeInitPolaris() {
    if (document.getElementById('weboffice_container')) {
      document.getElementById('weboffice_container').remove();
    }
    const newContainer = document.createElement('div');
    newContainer.id = 'weboffice_container';
    if (this.displayPolarisView && this.isEdited) {
      newContainer.style.height = '100%';
      const polarisArea = document.getElementById('polaris-area');
      polarisArea.appendChild(newContainer);
    } else if (this.displayPolarisEdit && this.isEdited) {
      newContainer.style.height = '100%';
      newContainer.style.width = '100%';
      newContainer.style.position = 'absolute';
      const polarisArea = document.getElementById('polaris-area');
      polarisArea.appendChild(newContainer);
    }
  }

  async downloadWordFromPolaris() {
    const fileNameDownloadFromS3 = this.getSelectedResource.docId + '.' + FILE_TYPES_ENUM.DOCX;
    const fileNameDownload = this.getSelectedResource.title + '.' + FILE_TYPES_ENUM.DOCX;
    await this.downloadAndViewReportFromS3(fileNameDownloadFromS3, false);
    if (this.fileBlobDownloadFromS3) {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(this.fileBlobDownloadFromS3);
      link.download = fileNameDownload;
      link.click();
    }
  }

  async downLoadPDFFromPolaris() {
    const fileNameDownload = this.getSelectedResource.title + '.' + FILE_TYPES_ENUM.PDF;
    this.polarisAPI
      .exportAsPDF({
        target: 'all', // For Word and Slide documents
        isPdfAExport: false, // Standard PDF export
      })
      .then(pdfDocument => {
        // Create a temporary URL for the PDF blob
        const url = URL.createObjectURL(pdfDocument.blob);

        // Create a hidden link to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.download = fileNameDownload || 'document.pdf';
        document.body.appendChild(link);
        link.click(); // Trigger download

        // Clean up
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.log('Failed to export as PDF:', error.message);
      });
  }

  print() {
    this.polarisAPI
      .exportAsPDF({
        target: 'all', // Export the entire document
        isPdfAExport: false,
      })
      .then(pdfDocument => {
        const url = URL.createObjectURL(pdfDocument.blob);
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);

        // Load PDF into iframe
        iframe.src = url;
        iframe.onload = () => {
          iframe.contentWindow.print(); // Trigger print
        };
      })
      .catch(error => {
        console.log('Failed to export as PDF:', error.message);
      });
  }
}
